import * as React from "react";
import { Box } from "@chakra-ui/react";

import background from "./back.png";

export const CityBackground = () => {
  return (
    <Box>
      <Box
        h="100vh"
        zIndex="0"
        backgroundImage={background}
        backgroundSize="cover"
      ></Box>
      <Box
        minH="100vh"
        zIndex="1"
        minWidth="100%"
        position="fixed"
        top="0"
        backdropFilter="blur(8px)"
      ></Box>
    </Box>
  );
};
